/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { loadWeb3, getWeb3Instance } from "./Connectivity/Connectivity";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";

import { TradeXTokenAddress, TradeXTokenAbi } from './Contract';

export default function TradeXToken() {
  const [btnTxt, setBtnTxt] = useState("Connect Wallet");
  const [account, setAccount] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [loadingStates, setLoadingStates] = useState({});
  
  // Function inputs and outputs storage
  const [functionInputs, setFunctionInputs] = useState({});
  const [functionOutputs, setFunctionOutputs] = useState({});
  
  // Overview data
  const [tokenData, setTokenData] = useState({
    name: "",
    symbol: "",
    decimals: 0,
    totalSupply: "",
    userBalance: "",
    paused: false,
    owner: ""
  });

  // Token contract functions definitions
  const tokenFunctions = {
    // Read Functions (View/Pure Functions)
    readFunctions: [
      {
        name: "name",
        title: "Name",
        description: "Get the token name",
        inputs: [],
        icon: "📛",
        category: "Basic Info"
      },
      {
        name: "symbol",
        title: "Symbol",
        description: "Get the token symbol",
        inputs: [],
        icon: "🔣",
        category: "Basic Info"
      },
      {
        name: "decimals",
        title: "Decimals",
        description: "Get the token decimals",
        inputs: [],
        icon: "🔢",
        category: "Basic Info"
      },
      {
        name: "totalSupply",
        title: "Total Supply",
        description: "Get the total supply",
        inputs: [],
        icon: "📊",
        category: "Basic Info"
      },
      {
        name: "owner",
        title: "Owner",
        description: "Get the contract owner",
        inputs: [],
        icon: "👑",
        category: "Basic Info"
      },
      {
        name: "paused",
        title: "Paused",
        description: "Check if contract is paused",
        inputs: [],
        icon: "⏸️",
        category: "Basic Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "pancakePair",
        title: "Pancake Pair",
        description: "Get the Pancake pair address",
        inputs: [],
        icon: "🔗",
        category: "Basic Info"
      },
      {
        name: "TradeXMarketplace",
        title: "TradeX Marketplace",
        description: "Get the TradeX marketplace address",
        inputs: [],
        icon: "🏪",
        category: "Basic Info"
      },
      {
        name: "multisendaccount",
        title: "Multisend Account",
        description: "Get the multisend account address",
        inputs: [],
        icon: "📤",
        category: "Basic Info"
      },
      {
        name: "maxBuyAmount",
        title: "Max Buy Amount",
        description: "Get the max buy amount",
        inputs: [],
        icon: "🛒",
        category: "Limits"
      },
      {
        name: "maxsSellingAmount",
        title: "Max Selling Amount",
        description: "Get the max selling amount",
        inputs: [],
        icon: "💸",
        category: "Limits"
      },
      {
        name: "maxTrPerDay",
        title: "Max Transfers Per Day",
        description: "Get the max transfers per day",
        inputs: [],
        icon: "🔄",
        category: "Limits"
      },
      {
        name: "maxMultisendPday",
        title: "Max Multisend Per Day",
        description: "Get the max multisend per day",
        inputs: [],
        icon: "📦",
        category: "Limits"
      },
      {
        name: "locktime",
        title: "Lock Time",
        description: "Get the lock time",
        inputs: [],
        icon: "🔒",
        category: "Limits"
      },
      {
        name: "balanceOf",
        title: "Balance Of",
        description: "Get balance of an account",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true }
        ],
        icon: "💰",
        category: "User Info"
      },
      {
        name: "allowance",
        title: "Allowance",
        description: "Get allowance for spender",
        inputs: [
          { name: "owner", type: "address", placeholder: "Enter owner address", required: true },
          { name: "spender", type: "address", placeholder: "Enter spender address", required: true }
        ],
        icon: "✅",
        category: "User Info"
      },
      {
        name: "nonces",
        title: "Nonces",
        description: "Get nonce for owner",
        inputs: [
          { name: "owner", type: "address", placeholder: "Enter owner address", required: true }
        ],
        icon: "🔢",
        category: "User Info"
      },
      {
        name: "blacklist",
        title: "Blacklist",
        description: "Check if address is blacklisted",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🚫",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "_isExcluded",
        title: "Is Excluded",
        description: "Check if address is excluded from limits",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🚫",
        category: "User Info",
        formatOutput: (value) => value ? 'Yes' : 'No'
      },
      {
        name: "_firstBuytime",
        title: "First Buy Time",
        description: "Get first buy time for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "⏰",
        category: "User Stats"
      },
      {
        name: "_firstSelltime",
        title: "First Sell Time",
        description: "Get first sell time for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "⏰",
        category: "User Stats"
      },
      {
        name: "_firstReceivetime",
        title: "First Receive Time",
        description: "Get first receive time for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "⏰",
        category: "User Stats"
      },
      {
        name: "_firstTransfer",
        title: "First Transfer",
        description: "Get first transfer for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "⏰",
        category: "User Stats"
      },
      {
        name: "_totTransfers",
        title: "Total Transfers",
        description: "Get total transfers for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🔄",
        category: "User Stats"
      },
      {
        name: "_totalAmountBuy",
        title: "Total Amount Buy",
        description: "Get total buy amount for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🛒",
        category: "User Stats"
      },
      {
        name: "_totalAmountSell",
        title: "Total Amount Sell",
        description: "Get total sell amount for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "💸",
        category: "User Stats"
      },
      {
        name: "_totalAmountreceive",
        title: "Total Amount Receive",
        description: "Get total receive amount for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "📥",
        category: "User Stats"
      },
      {
        name: "buying",
        title: "Buying",
        description: "Get buying stat for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🛒",
        category: "User Stats"
      },
      {
        name: "selling",
        title: "Selling",
        description: "Get selling stat for address",
        inputs: [
          { name: "address", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "💸",
        category: "User Stats"
      },
      {
        name: "DOMAIN_SEPARATOR",
        title: "Domain Separator",
        description: "Get the EIP712 domain separator",
        inputs: [],
        icon: "📜",
        category: "Advanced"
      },
      {
        name: "eip712Domain",
        title: "EIP712 Domain",
        description: "Get the EIP712 domain info",
        inputs: [],
        icon: "📜",
        category: "Advanced",
        formatOutput: (value) => JSON.stringify(value, null, 2)
      }
    ],
    
    // Write Functions (Transaction Functions)
    writeFunctions: [
      {
        name: "Buy",
        title: "Buy",
        description: "Buy tokens with BNB",
        inputs: [
          { name: "amount", type: "uint256", placeholder: "Enter BNB amount (in wei)", required: true, isValue: true }
        ],
        isPayable: true,
        icon: "🛒",
        category: "Actions"
      },
      {
        name: "Sell",
        title: "Sell",
        description: "Sell tokens",
        inputs: [
          { name: "_token", type: "uint256", placeholder: "Enter token amount", required: true }
        ],
        icon: "💸",
        category: "Actions"
      },
      {
        name: "approve",
        title: "Approve",
        description: "Approve spender",
        inputs: [
          { name: "spender", type: "address", placeholder: "Enter spender address", required: true },
          { name: "value", type: "uint256", placeholder: "Enter value", required: true }
        ],
        icon: "✅",
        category: "Actions"
      },
      {
        name: "transfer",
        title: "Transfer",
        description: "Transfer tokens",
        inputs: [
          { name: "to", type: "address", placeholder: "Enter recipient address", required: true },
          { name: "value", type: "uint256", placeholder: "Enter value", required: true }
        ],
        icon: "➡️",
        category: "Actions"
      },
      {
        name: "transferFrom",
        title: "Transfer From",
        description: "Transfer tokens from another address",
        inputs: [
          { name: "from", type: "address", placeholder: "Enter from address", required: true },
          { name: "to", type: "address", placeholder: "Enter to address", required: true },
          { name: "value", type: "uint256", placeholder: "Enter value", required: true }
        ],
        icon: "🔄",
        category: "Actions"
      },
      {
        name: "burn",
        title: "Burn",
        description: "Burn tokens",
        inputs: [
          { name: "value", type: "uint256", placeholder: "Enter value", required: true }
        ],
        icon: "🔥",
        category: "Actions"
      },
      {
        name: "burnFrom",
        title: "Burn From",
        description: "Burn tokens from another address",
        inputs: [
          { name: "account", type: "address", placeholder: "Enter account address", required: true },
          { name: "value", type: "uint256", placeholder: "Enter value", required: true }
        ],
        icon: "🔥",
        category: "Actions"
      },
      {
        name: "multiSendToken",
        title: "Multi Send Token",
        description: "Send tokens to multiple addresses",
        inputs: [
          { name: "_contributors", type: "address[]", placeholder: "Enter contributors (comma-separated)", required: true },
          { name: "__balances", type: "uint256[]", placeholder: "Enter balances (comma-separated)", required: true }
        ],
        icon: "📦",
        category: "Actions"
      },
      {
        name: "permit",
        title: "Permit",
        description: "Permit spender via signature",
        inputs: [
          { name: "owner", type: "address", placeholder: "Enter owner", required: true },
          { name: "spender", type: "address", placeholder: "Enter spender", required: true },
          { name: "value", type: "uint256", placeholder: "Enter value", required: true },
          { name: "deadline", type: "uint256", placeholder: "Enter deadline", required: true },
          { name: "v", type: "uint8", placeholder: "Enter v", required: true },
          { name: "r", type: "bytes32", placeholder: "Enter r", required: true },
          { name: "s", type: "bytes32", placeholder: "Enter s", required: true }
        ],
        icon: "✍️",
        category: "Advanced"
      }
    ],

    // Admin Functions
    adminFunctions: [
      {
        name: "pause",
        title: "Pause",
        description: "Pause the contract",
        inputs: [],
        icon: "⏸️",
        category: "Admin Control"
      },
      {
        name: "unpause",
        title: "Unpause",
        description: "Unpause the contract",
        inputs: [],
        icon: "▶️",
        category: "Admin Control"
      },
      {
        name: "renounceOwnership",
        title: "Renounce Ownership",
        description: "Renounce ownership",
        inputs: [],
        icon: "👑",
        category: "Admin Control"
      },
      {
        name: "transferOwnership",
        title: "Transfer Ownership",
        description: "Transfer ownership",
        inputs: [
          { name: "newOwner", type: "address", placeholder: "Enter new owner", required: true }
        ],
        icon: "🔄",
        category: "Admin Control"
      },
      {
        name: "initialize",
        title: "Initialize",
        description: "Initialize the contract",
        inputs: [
          { name: "initialOwner", type: "address", placeholder: "Enter initial owner", required: true }
        ],
        icon: "🚀",
        category: "Admin Control"
      },
      {
        name: "addPairAddress",
        title: "Add Pair Address",
        description: "Add pair address",
        inputs: [
          { name: "_pair", type: "address", placeholder: "Enter pair address", required: true }
        ],
        icon: "🔗",
        category: "Admin Settings"
      },
      {
        name: "addToblackList",
        title: "Add To Blacklist",
        description: "Add address to blacklist",
        inputs: [
          { name: "_addr", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "🚫",
        category: "Admin Settings"
      },
      {
        name: "removeFromBlackList",
        title: "Remove From Blacklist",
        description: "Remove address from blacklist",
        inputs: [
          { name: "_addr", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "✅",
        category: "Admin Settings"
      },
      {
        name: "ExcludefromLimits",
        title: "Exclude From Limits",
        description: "Exclude address from limits",
        inputs: [
          { name: "_addr", type: "address", placeholder: "Enter address", required: true },
          { name: "_state", type: "bool", placeholder: "Enter state (true/false)", required: true }
        ],
        icon: "🚫",
        category: "Admin Settings"
      },
      {
        name: "setBuyLimit",
        title: "Set Buy Limit",
        description: "Set buy limit",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "🛒",
        category: "Admin Limits"
      },
      {
        name: "setMaxSell",
        title: "Set Max Sell",
        description: "Set max sell amount",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "💸",
        category: "Admin Limits"
      },
      {
        name: "setPerDayTransferLimit",
        title: "Set Per Day Transfer Limit",
        description: "Set per day transfer limit",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "🔄",
        category: "Admin Limits"
      },
      {
        name: "setMaxMultiSendPday",
        title: "Set Max Multisend Per Day",
        description: "Set max multisend per day",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "📦",
        category: "Admin Limits"
      },
      {
        name: "setMultiSendAccount",
        title: "Set Multisend Account",
        description: "Set multisend account",
        inputs: [
          { name: "_addr", type: "address", placeholder: "Enter address", required: true }
        ],
        icon: "📤",
        category: "Admin Settings"
      },
      {
        name: "setTradeXMarketplaceContract",
        title: "Set TradeX Marketplace Contract",
        description: "Set TradeX marketplace contract",
        inputs: [
          { name: "newTradeXMarketplace", type: "address", placeholder: "Enter new address", required: true }
        ],
        icon: "🏪",
        category: "Admin Settings"
      },
      {
        name: "mint",
        title: "Mint",
        description: "Mint new tokens",
        inputs: [
          { name: "to", type: "address", placeholder: "Enter recipient", required: true },
          { name: "amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "🪙",
        category: "Admin Actions"
      },
      {
        name: "WithDrawBNB",
        title: "Withdraw BNB",
        description: "Withdraw BNB from contract",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "💎",
        category: "Admin Recovery"
      },
      {
        name: "getTokens",
        title: "Get Tokens",
        description: "Withdraw tokens from contract",
        inputs: [
          { name: "_amount", type: "uint256", placeholder: "Enter amount", required: true }
        ],
        icon: "🪙",
        category: "Admin Recovery"
      }
    ]
  };

  const connectWallet = async () => {
    setLoadingStates(prev => ({ ...prev, connect: true }));
    
    try {
      const acc = await loadWeb3();
      if (acc === "No Wallet") {
        toast.error("No Wallet Detected");
        setBtnTxt("Connect Wallet");
      } else if (acc === "Wrong Network") {
        toast.error("Please switch to opBNB Mainnet");
        setBtnTxt("Wrong Network");
      } else {
        setAccount(acc);
        setBtnTxt(acc.substring(0, 6) + '...' + acc.substring(acc.length - 4));
        toast.success("Connected to opBNB Mainnet");
        
        loadTokenData();
      }
    } catch (error) {
      console.error("Connection error:", error);
      toast.error("Connection failed");
      setBtnTxt("Connect Wallet");
    } finally {
      setLoadingStates(prev => ({ ...prev, connect: false }));
    }
  };

  const getContract = () => {
    const web3 = getWeb3Instance();
    return new web3.eth.Contract(TradeXTokenAbi, TradeXTokenAddress);
  };

  const loadTokenData = useCallback(async () => {
    if (!account) return;
    
    try {
      const web3 = getWeb3Instance();
      const contract = getContract();
      
      const [name, symbol, decimals, totalSupply, paused, owner, userBalance] = await Promise.all([
        contract.methods.name().call().catch(() => ""),
        contract.methods.symbol().call().catch(() => ""),
        contract.methods.decimals().call().catch(() => 0),
        contract.methods.totalSupply().call().catch(() => "0"),
        contract.methods.paused().call().catch(() => false),
        contract.methods.owner().call().catch(() => ""),
        contract.methods.balanceOf(account).call().catch(() => "0")
      ]);

      setTokenData({
        name,
        symbol,
        decimals: parseInt(decimals),
        totalSupply: web3.utils.fromWei(totalSupply.toString(), 'ether'),
        paused,
        owner,
        userBalance: web3.utils.fromWei(userBalance.toString(), 'ether')
      });
      
    } catch (error) {
      console.error("Error loading token data:", error);
      toast.error("Failed to load token data");
    }
  }, [account]);

  useEffect(() => {
    if (account) {
      loadTokenData();
    }
  }, [account, loadTokenData]);

  const handleInputChange = (functionName, inputName, value) => {
    setFunctionInputs(prev => ({
      ...prev,
      [functionName]: {
        ...prev[functionName],
        [inputName]: value
      }
    }));
  };

  const executeReadFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      
      const args = functionData.inputs.map(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        if (input.type.includes('[]') && typeof value === 'string') {
          return value.split(',').map(v => v.trim());
        }
        if (input.type === 'bool') {
          return value.toLowerCase() === 'true';
        }
        return value || '';
      });

      const result = await contract.methods[functionData.name](...args).call();
      
      const formattedResult = functionData.formatOutput 
        ? functionData.formatOutput(result)
        : JSON.stringify(result, (key, value) => typeof value === 'bigint' ? value.toString() : value, 2);

      setFunctionOutputs(prev => ({
        ...prev,
        [funcKey]: formattedResult
      }));

      toast.success("Read operation successful!");
    } catch (error) {
      console.error("Read error:", error);
      toast.error(error.message || "Read operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const executeWriteFunction = async (functionData) => {
    if (!account) {
      toast.error("Please connect your wallet first");
      return;
    }

    const funcKey = functionData.name;
    setLoadingStates(prev => ({ ...prev, [funcKey]: true }));
    try {
      const contract = getContract();
      const inputs = functionInputs[funcKey] || {};
      
      let args = [];
      let txValue = '0';
      functionData.inputs.forEach(input => {
        const value = inputs[input.name];
        if (input.required && (!value || value.trim() === '')) {
          throw new Error(`${input.name} is required`);
        }
        if (input.isValue) {
          txValue = value;
          return;
        }
        let parsedValue = value || '';
        if (input.type.includes('[]') && typeof parsedValue === 'string') {
          parsedValue = parsedValue.split(',').map(v => v.trim());
        }
        if (input.type === 'bool') {
          parsedValue = parsedValue.toLowerCase() === 'true';
        }
        if (input.type === 'uint8') {
          parsedValue = parseInt(parsedValue);
        }
        args.push(parsedValue);
      });

      const txOptions = {
        from: account
      };
      if (functionData.isPayable && txValue !== '0') {
        txOptions.value = txValue;
      }

      const tx = await contract.methods[functionData.name](...args).send(txOptions);

      toast.success(`Transaction successful! Hash: ${tx.transactionHash}`);
      loadTokenData();
    } catch (error) {
      console.error("Write error:", error);
      toast.error(error.message || "Write operation failed");
    } finally {
      setLoadingStates(prev => ({ ...prev, [funcKey]: false }));
    }
  };

  const groupFunctionsByCategory = (functions) => {
    return functions.reduce((acc, func) => {
      const cat = func.category || 'Other';
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(func);
      return acc;
    }, {});
  };

  const renderFunctionCard = (func, isWrite = false, isAdmin = false) => {
    const funcKey = func.name;
    const inputs = functionInputs[funcKey] || {};
    const output = functionOutputs[funcKey];
    const isLoading = loadingStates[funcKey] || false;

    return (
      <div key={funcKey} className="col-lg-4 col-md-6 mb-4">
        <div className="card h-100 shadow-lg border-0" style={{
          borderRadius: '20px',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div className="card-body p-4 d-flex flex-column">
            <div className="d-flex align-items-center mb-3">
              <span className="fs-3 me-3">{func.icon}</span>
              <div>
                <h5 className="mb-1 text-white">{func.title}</h5>
                <small className="text-white-50">{func.description}</small>
              </div>
            </div>

            {func.inputs.map(input => (
              <div key={input.name} className="mb-3">
                <input
                  type="text"
                  className="form-control bg-dark border-0 text-white placeholder-white"
                  placeholder={input.placeholder}
                  value={inputs[input.name] || ''}
                  onChange={(e) => handleInputChange(funcKey, input.name, e.target.value)}
                  style={{
                    borderRadius: '12px',
                    padding: '12px'
                  }}
                />
              </div>
            ))}

            <button 
              onClick={() => isWrite || isAdmin 
                ? executeWriteFunction(func)
                : executeReadFunction(func)}
              disabled={isLoading}
              className="btn w-100 mt-auto"
              style={{
                background: isWrite || isAdmin 
                  ? 'linear-gradient(135deg, #ff6b6b, #4ecdc4)' 
                  : 'linear-gradient(135deg, #00ff88, #00ccff)',
                border: 'none',
                color: '#fff',
                borderRadius: '12px',
                padding: '12px',
                fontWeight: '600'
              }}
            >
              {isLoading ? 'Processing...' : (isWrite || isAdmin ? 'Execute Write' : 'Read')}
            </button>

            {output && (
              <div className="mt-3 p-3 rounded-3" style={{
                background: 'rgba(0, 255, 136, 0.1)',
                border: '1px solid rgba(0, 255, 136, 0.3)',
                whiteTradeX: 'pre-wrap',
                overflow: 'auto',
                maxHeight: '200px'
              }}>
                <small className="text-white-50 d-block mb-2">Output:</small>
                <code className="text-white">{output}</code>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4" style={{
      background: 'linear-gradient(135deg, #000428, #004e92)'
    }}>
      <div className="container text-center">
        <h1 className="mb-5 display-4 fw-bold" style={{
          background: 'linear-gradient(135deg, #00ff88, #00ccff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          TradeX Token Dashboard
        </h1>

        <div className="mb-5">
          <button 
            onClick={connectWallet}
            disabled={loadingStates.connect}
            className="btn px-4 px-md-5 py-3 rounded-pill shadow-lg position-relative overflow-hidden"
            style={{ 
              background: account ? 
                'linear-gradient(135deg, #00ff88, #00ccff)' : 
                'linear-gradient(135deg, #ff6b6b, #4ecdc4)',
              border: 'none',
              color: account ? '#000' : '#fff',
              fontSize: 'clamp(0.9rem, 3vw, 1.1rem)', 
              fontWeight: '700',
              transition: 'all 0.3s ease',
              minWidth: '160px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              opacity: loadingStates.connect ? 0.7 : 1
            }}
          >
            {loadingStates.connect ? (
              <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                Connecting...
              </div>
            ) : (
              <span className="position-relative">{btnTxt}</span>
            )}
          </button>
        </div>
        
        {account && (
          <div className="mt-4 p-3 rounded-4" style={{
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <span className="text-white-50 small">
                🔗 {account.substring(0, 6)}...{account.substring(account.length - 4)}
              </span>
              <span className="badge bg-success rounded-pill">Connected</span>
            </div>
          </div>
        )}

        {account && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-lg border-0 mb-4" style={{ 
                borderRadius: '24px',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255, 255, 255, 0.1)'
              }}>
                <div className="card-header border-0 p-4" style={{ 
                  borderRadius: '24px 24px 0 0',
                  background: 'transparent'
                }}>
                  <ul className="nav nav-pills justify-content-center flex-wrap gap-2" role="tablist">
                    {[
                      { key: 'overview', label: 'Overview', icon: '📊', color: '#00ff88' },
                      { key: 'read', label: 'Read Functions', icon: '👁️', color: '#45b7d1' },
                      { key: 'write', label: 'Write Functions', icon: '📝', color: '#4ecdc4' },
                      { key: 'admin', label: 'Admin Functions', icon: '⚙️', color: '#ff6b6b' }
                    ].map(tab => (
                      <li key={tab.key} className="nav-item">
                        <button
                          className={`nav-link border-0 px-4 py-3 fw-bold position-relative overflow-hidden ${
                            activeTab === tab.key ? 'text-dark' : 'text-white-50'
                          }`}
                          onClick={() => setActiveTab(tab.key)}
                          style={{
                            borderRadius: '16px',
                            background: activeTab === tab.key ? 
                              `linear-gradient(135deg, ${tab.color}, ${tab.color}80)` : 
                              'rgba(255, 255, 255, 0.05)',
                            border: activeTab === tab.key ? 
                              `1px solid ${tab.color}` : 
                              '1px solid rgba(255, 255, 255, 0.1)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            transform: activeTab === tab.key ? 'translateY(-2px)' : 'translateY(0)',
                            boxShadow: activeTab === tab.key ? 
                              `0 8px 25px ${tab.color}40` : 'none'
                          }}
                        >
                          <span className="me-2 fs-5">{tab.icon}</span>
                          <span className="d-none d-md-inline">{tab.label}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="card-body p-4" style={{
                  background: 'rgba(0, 0, 0, 0.2)',
                  borderRadius: '0 0 24px 24px'
                }}>
                  {/* Overview Tab */}
                  {activeTab === 'overview' && (
                    <div className="row g-4">
                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">📛</div>
                            <h4 className="text-white mb-2">{tokenData.name || 'N/A'}</h4>
                            <p className="text-white-50 mb-0">Token Name</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(tokenFunctions.readFunctions.find(f => f.name === 'name'))}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(69, 183, 209, 0.15), rgba(107, 224, 215, 0.1))',
                          border: '1px solid rgba(69, 183, 209, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">🔣</div>
                            <h4 className="text-white mb-2">{tokenData.symbol || 'N/A'}</h4>
                            <p className="text-white-50 mb-0">Token Symbol</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(tokenFunctions.readFunctions.find(f => f.name === 'symbol'))}
                              style={{
                                background: 'rgba(69, 183, 209, 0.2)',
                                border: '1px solid #45b7d1',
                                color: '#45b7d1'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: `linear-gradient(135deg, ${tokenData.paused ? 'rgba(255, 107, 107, 0.15)' : 'rgba(0, 255, 136, 0.15)'}, rgba(255, 170, 0, 0.1))`,
                          border: `1px solid ${tokenData.paused ? 'rgba(255, 107, 107, 0.3)' : 'rgba(0, 255, 136, 0.3)'}`,
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">{tokenData.paused ? '⏸️' : '▶️'}</div>
                            <h4 className="text-white mb-2">
                              {tokenData.paused ? 'PAUSED' : 'ACTIVE'}
                            </h4>
                            <p className="text-white-50 mb-0">Contract Status</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(tokenFunctions.readFunctions.find(f => f.name === 'paused'))}
                              style={{
                                background: tokenData.paused ? 
                                  'rgba(255, 107, 107, 0.2)' : 'rgba(0, 255, 136, 0.2)',
                                border: tokenData.paused ? 
                                  '1px solid #ff6b6b' : '1px solid #00ff88',
                                color: tokenData.paused ? '#ff6b6b' : '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(255, 170, 0, 0.15), rgba(255, 107, 107, 0.1))',
                          border: '1px solid rgba(255, 170, 0, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">📊</div>
                            <h4 className="text-white mb-2">{tokenData.totalSupply || '0'}</h4>
                            <p className="text-white-50 mb-0">Total Supply</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(tokenFunctions.readFunctions.find(f => f.name === 'totalSupply'))}
                              style={{
                                background: 'rgba(255, 170, 0, 0.2)',
                                border: '1px solid #ffaa00',
                                color: '#ffaa00'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(0, 255, 136, 0.15), rgba(69, 183, 209, 0.1))',
                          border: '1px solid rgba(0, 255, 136, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">💼</div>
                            <h4 className="text-white mb-2">{tokenData.userBalance || '0'}</h4>
                            <p className="text-white-50 mb-0">Your Balance</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={loadTokenData}
                              style={{
                                background: 'rgba(0, 255, 136, 0.2)',
                                border: '1px solid #00ff88',
                                color: '#00ff88'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-6">
                        <div className="card h-100 border-0" style={{ 
                          borderRadius: '20px',
                          background: 'linear-gradient(135deg, rgba(69, 183, 209, 0.15), rgba(107, 224, 215, 0.1))',
                          border: '1px solid rgba(69, 183, 209, 0.3)',
                          backdropFilter: 'blur(10px)'
                        }}>
                          <div className="card-body p-4 text-center">
                            <div className="fs-1 mb-3">👑</div>
                            <h4 className="text-white mb-2">{tokenData.owner.substring(0, 6) + '...' + tokenData.owner.substring(tokenData.owner.length - 4) || 'N/A'}</h4>
                            <p className="text-white-50 mb-0">Owner</p>
                            <button 
                              className="btn btn-sm mt-3 w-100"
                              onClick={() => executeReadFunction(tokenFunctions.readFunctions.find(f => f.name === 'owner'))}
                              style={{
                                background: 'rgba(69, 183, 209, 0.2)',
                                border: '1px solid #45b7d1',
                                color: '#45b7d1'
                              }}
                            >
                              🔄 Refresh
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Read Functions Tab */}
                  {activeTab === 'read' && (
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="mb-0 text-info">👁️ Read Functions</h4>
                        <small className="text-white-50">
                          {tokenFunctions.readFunctions.length} functions available
                        </small>
                      </div>
                      {Object.entries(groupFunctionsByCategory(tokenFunctions.readFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50 d-flex align-items-center">
                            <span className="me-2">{category}</span>
                            <span className="badge bg-secondary rounded-pill">{funcs.length}</span>
                          </h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, false, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Write Functions Tab */}
                  {activeTab === 'write' && (
                    <div>
                      <h4 className="mb-4" style={{color: '#4ecdc4'}}>📝 Write Functions</h4>
                      {Object.entries(groupFunctionsByCategory(tokenFunctions.writeFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, false))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Admin Functions Tab */}
                  {activeTab === 'admin' && (
                    <div>
                      <h4 className="mb-4 text-danger">⚙️ Admin Functions</h4>
                      <div className="alert alert-warning">
                        <strong>⚠️ Warning:</strong> These functions are restricted to contract owner/admin only.
                      </div>
                      {Object.entries(groupFunctionsByCategory(tokenFunctions.adminFunctions)).map(([category, funcs]) => (
                        <div key={category} className="mb-5">
                          <h5 className="mb-3 text-white-50">{category}</h5>
                          <div className="row">
                            {funcs.map(func => renderFunctionCard(func, true, true))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}